import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { searchInvoiceVerificationData, smartSearchInvoiceVerificationData } from '../../../api/invoiceVerification'
import { raiseToast } from '../toast/toast'

export const fetchInvoiceVerificationData = createAsyncThunk('invoice/getInvoiceVerification', async (params, { dispatch }) => {
    let response = []
    if(params.smartSearch){
        response = await smartSearchInvoiceVerificationData(params)
    }
    else{
        response = await searchInvoiceVerificationData(params)        
    }
    
    if(response.failure){
        return dispatch(raiseToast({severity:'error', summary: "Invoice Verification", detail: response.data.error, life: 3000}))
    }
    console.log("invoice verification res", response.data)
    return response.data
})

export const invoiceVerificationSlice = createSlice({
    name : "invoice/getInvoiceVerification",
    initialState : {
        loading: false,
        invoiceVerificationData: [],
        paginationParams: {
            pageNo: 0,
            totalRecords: 0,
            recordsPerPage: 10,
            limitedPagination: true,
            getCount: true
        },
        searchParams: {
            dataType: "invoiceVerificationData",
            dateType: "piUploadedDate",
            searchBy: "all",
            searchText: "",
            fromDate: new Date()
        },
        searchOptions: [],
        isSearchVisible: false,
        isSearchPinned: true,
        isSearchByLocked: false
    },
    reducers: {
        updateSearchOptions: (state, action) => {
            state.searchOptions = action.payload
        },
        updateSearchParams: (state, action) => {
            state.searchParams = action.payload
        },
        updateInvoiceVerificationData: (state, action) => {
            state.invoiceVerificationData = action.payload
        },
        updateLoading: (state, action) => {
            state.loading = action.payload
        },
        setIsSearchVisible: (state, action) => {
            state.isSearchVisible = action.payload
        },
        setIsSearchPinned: (state, action) => {
            state.isSearchPinned = action.payload
        },
        setIsSearchByLocked: (state, action) => {
            state.isSearchByLocked = action.payload
        },
    },
    extraReducers : (builder) => {
        builder.addCase(
            fetchInvoiceVerificationData.fulfilled, (state, action) => {
                state.loading = false 
                state.invoiceVerificationData = action.payload.data
                state.vendorPayments = action.payload.vendorPayments?.length ? action.payload.vendorPayments : []
                state.paginationParams.pageNo = action.payload.pageNo-1
                state.paginationParams.recordsPerPage = action.payload.recordsPerPage 
                if(action.payload.totalRecords || action.payload.totalRecords === 0){
                    state.paginationParams.totalRecords = action.payload.totalRecords
                }
            }
        )
        .addCase(
            fetchInvoiceVerificationData.pending, (state, action) => {
                state.loading = true 
            }
        )
        .addCase(
            fetchInvoiceVerificationData.rejected, (state, action) => {
                state.loading = false
            }
        )
    }

})

export const { updateSearchParams, updateSearchOptions, updateInvoiceVerificationData, updateLoading, setIsSearchVisible, setIsSearchPinned, setIsSearchByLocked } = invoiceVerificationSlice.actions

export default invoiceVerificationSlice.reducer